/* ================================================================================================
   WHAT'S INCLUDED, PER VARIANT — show the row belonging to the selected variant
   ================================================================================================
   Every variant's row is in the DOM; this only decides which one is visible.

   Bound on document, not on the rows: the form dispatches variant:change and it bubbles, and binding
   per row would miss any row the theme replaces. The server already renders the correct row visible
   on load, so this handles changes only.
   ================================================================================================ */
(function () {
  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;

    document.querySelectorAll('[data-vc-variant-id]').forEach(function (row) {
      row.hidden = String(row.getAttribute('data-vc-variant-id')) !== String(variant.id);
    });
  });
})();
